import React from 'react';
import { StyledRootWrapper } from "./RootWrapper.styles";

export const RootWrapper:React.FC = (props) => {
    return <StyledRootWrapper {...props} />
};
